function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEditRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 28v2H4v-2h24zM17.746 5.447l5.397 5.398 1.414 1.414-11.794 11.794L4 26l1.947-8.763L17.741 5.444l.005.003zM6.634 23.367l4.441-.988-3.454-3.453-.987 4.44zm2.135-6.123l3.987 3.987 8.973-8.972L17.74 8.27 8.77 17.244zM20.598 2.587a2.001 2.001 0 012.832 0l3.984 3.983c.782.782.782 2.05 0 2.832l-1.442 1.443-1.415-1.414 1.442-1.443-3.987-3.987-1.443 1.442-1.414-1.414 1.443-1.442z",
    fill: props.color
  }));
}

export default SvgIconEditRexOutline;